import { motion } from 'framer-motion';
import { useTheme } from '@/contexts/ThemeContext';

export default function AnimatedBackground() {
  const { isDark } = useTheme();

  // En mode clair, on n'affiche pas les orbes
  if (!isDark) return null;

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Orbe principale - violet */}
      <motion.div
        className="absolute w-[600px] h-[600px] rounded-full opacity-25"
        style={{
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, transparent 70%)',
          filter: 'blur(80px)',
          top: '-15%',
          right: '-10%',
        }}
        animate={{
          x: [0, 30, -20, 0],
          y: [0, -40, 20, 0],
          scale: [1, 1.1, 0.95, 1],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      
      {/* Orbe secondaire - rose */}
      <motion.div
        className="absolute w-[500px] h-[500px] rounded-full opacity-20"
        style={{
          background: 'radial-gradient(circle, rgba(236, 72, 153, 0.35) 0%, transparent 70%)',
          filter: 'blur(70px)',
          bottom: '5%',
          left: '-10%',
        }}
        animate={{
          x: [0, 50, -30, 0],
          y: [0, 30, -20, 0],
          scale: [1, 0.9, 1.1, 1],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      
      {/* Orbe tertiaire - violet clair */}
      <motion.div
        className="absolute w-[350px] h-[350px] rounded-full opacity-15"
        style={{
          background: 'radial-gradient(circle, rgba(167, 139, 250, 0.35) 0%, transparent 70%)',
          filter: 'blur(60px)',
          top: '35%',
          right: '15%',
        }}
        animate={{
          x: [0, -40, 30, 0],
          y: [0, 20, -30, 0],
        }}
        transition={{
          duration: 18,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 2,
        }}
      />
      
      {/* Petites particules flottantes */}
      <motion.div
        className="absolute w-2 h-2 rounded-full bg-violet-400/30"
        style={{ top: '20%', left: '15%' }}
        animate={{
          y: [0, -25, 0],
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      
      <motion.div
        className="absolute w-2.5 h-2.5 rounded-full bg-pink-400/25"
        style={{ top: '55%', right: '20%' }}
        animate={{
          y: [0, -20, 0],
          opacity: [0.25, 0.5, 0.25],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1,
        }}
      />
      
      <motion.div
        className="absolute w-1.5 h-1.5 rounded-full bg-violet-300/30"
        style={{ bottom: '25%', left: '35%' }}
        animate={{
          y: [0, -18, 0],
          opacity: [0.3, 0.55, 0.3],
        }}
        transition={{
          duration: 3.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.5,
        }}
      />
    </div>
  );
}
